module.exports = __webpack_public_path__ + "img/9788932025353.b20f89e1.jpg";